var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasPointsTable
    ? _c(
        "div",
        { staticClass: "pt-table" },
        _vm._l(_vm.getStandingArr(), function (group, g_idx) {
          return _c("div", { key: g_idx }, [
            group[0] && group[0].group_name
              ? _c("div", { staticClass: "table-header" }, [
                  _c("h2", { staticClass: "title" }, [
                    _vm._v(_vm._s(group[0].group_name)),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "table-responsive points-table" }, [
              _c("table", { staticClass: "table" }, [
                _c("thead", [
                  _c(
                    "tr",
                    _vm._l(_vm.tableCols, function (c, c_idx) {
                      return _c(
                        "th",
                        { key: c_idx, attrs: { title: c.title } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(c.displayName) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(group, function (t, t_idx) {
                    return _c(
                      "tr",
                      { key: t_idx },
                      _vm._l(_vm.tableCols, function (c, c_idx) {
                        return _c("td", { key: c_idx }, [
                          c.showQualifer && t.is_qualified
                            ? _c("span", { staticClass: "qualifier-badge" }, [
                                _vm._v("Q"),
                              ])
                            : _c("span", [_vm._v(_vm._s(t[c.key]))]),
                        ])
                      }),
                      0
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ])
        }),
        0
      )
    : _c("div", { staticClass: "no-data" }, [
        _c("p", { staticClass: "msg" }, [
          _vm._v("Points table not available for this series."),
        ]),
        _vm._v(" "),
        _vm.pageOptionForNoPtsTable
          ? _c("p", { staticClass: "msg" }, [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.pageOptionForNoPtsTable.preText) +
                  "\n    "
              ),
              _c(
                "a",
                {
                  staticClass: "no-data-link",
                  attrs: { href: _vm.pageOptionForNoPtsTable.linkUrl },
                },
                [_vm._v(_vm._s(_vm.pageOptionForNoPtsTable.linkLabel))]
              ),
              _vm._v(
                "\n    " + _vm._s(_vm.pageOptionForNoPtsTable.postText) + "\n  "
              ),
            ])
          : _vm._e(),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }